import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import BZLogo from "../../components/BZLogo";
import { TwButton, TwCalendarPicker, TwDropzone, TwFormHelperText, TwInputGroup, TwMainLayout, TwPhoneInputGroup, TwSelectGroup, TwStoreButton } from "../../components/tailwind";
import { getInitialsUrl, handleUploadImageToS3, isValidEmail } from "../../helpers";
import { useLocalStorage } from "../../hooks";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import "../../styles/SignUp.css";
import axiosInstance from "../../utils/axiosInstance";
import { getDomainUrl, getUrlForBookings, getUrlForUsers } from "../../utils/confighelpers";
import axios from "axios";
import { ArrowRightIcon, EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import calender_black from "../../assets/calender_black.svg";
import customer_name from "../../assets/customer_name.svg";
import email_img from "../../assets/Email.svg";
import lock_img from "../../assets/password.svg";
import FitClubLogo from "../../components/FitClubLogo";
// import avatar_placeholder_vector from "../../assets/avatar_placeholder.svg";
import avatar_placeholder_vector from "../../assets/avatar_placeholder.svg";
import Dropzone from "react-dropzone";
import OtpModal from "../../components/OtpModal";
import moment from "moment";
import { DEFAULT_TENANT, useTenant } from "../../provider/TenantProvider";
import AuthShell, { AuthHeading, PrimaryAuthButton } from "../../components/auth/AuthShell";
import { ignoreDomainList } from "../../utils/constants";
import confetti from "canvas-confetti";
import * as userActions from "../../redux/reducers/userReducer";

export default function SignupWithPublickLink({ navigation, logFor }) {

  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog, addConfirmDialog } = useToast();
  const { myBookingLink } = useParams();
  const { tenant, tenantData, tenantLoading } = useTenant();
  const urlParams = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const userReduxState = useSelector(userState);
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const [businessDetail, setBusinessDetail] = React.useState({});
  const [passwordVisible, setPasswordVisible] = React.useState(false);

  const defaultFormData = {
    profilePic: "",
    // fullName: "abhijit74",
    // username: "+31940800217",
    // email: "abhijit74@yopmail.com",
    // password: "Test@123",
    fullName: "",
    username: "",
    email: "",
    password: "",
    gender: "",
    dob: "",
    actionType: "free_trial_credit",
    migrationCredit: 0,
  }
  const [formValues, setFormValues] = React.useState(defaultFormData);
  const [formErrors, setFormErrors] = React.useState({});
  const [openOtpModal, setOpenOtpModal] = React.useState(false);
  const [signupComplete, setSignupComplete] = React.useState(false);
  const [otpToken, setOtpToken] = React.useState("");
  /** the club already made this account (Add member / import); signing up with the same mobile number activates it */
  const [addedByClub, setAddedByClub] = React.useState(false);



  const getHostHomePage = async () => {
    console.log("myBookingLink", myBookingLink);

    const config = {
      method: "get",
      url: `${getUrlForUsers()}getHostHomePage?businessName=${logFor == "tenant" && tenant !== DEFAULT_TENANT ? tenant : myBookingLink}`,
    };
    dispatch(setGlobalLoading(true));
    const request = await axios(config).catch(async (e) => {
      console.error("Session Has Expired");
      if (e.response && (e.response.status === 401 || e.response.status === 502)) {
        console.error("Session Has Expired");
        addNotificationDialog({
          dialogType: "error",
          dialogTitle: "Sorry!",
          dialogMessage: "This business is not currently available. Please try again later",
          dialogBtnTitle: "OK",
          isAllowBackdropClick: false,
          isDialogBtnShow: false,
          dialogBtnClick: async () => {
            // navigate("/", { replace: true });
          },
        })
        // await setUserToken("");
        // window.location.href = "/";
      }

    });
    dispatch(setGlobalLoading(false));
    if (request.data.statusCode === 200) {
      // console.log("data", request.data.data);
      const userData = request.data.data;
      setBusinessDetail(userData)

    } else {
      addNotificationDialog({
        dialogType: "error",
        dialogTitle: "Sorry!",
        dialogMessage: "This business is not currently available. Please try again later",
        dialogBtnTitle: "OK",
        isAllowBackdropClick: false,
        isDialogBtnShow: false,
        dialogBtnClick: async () => {
          // navigate("/", { replace: true });
        },
      })
    }
  }

  const validateForm = () => {
    const errors = {};
    // if (!formValues?.profilePic || formValues?.profilePic === "") {
    //   errors.profilePic = "Required!";
    // }
    if (!formValues?.fullName || formValues?.fullName === "") {
      errors.fullName = "Required!";
    }
    if (!formValues?.phone) {
      errors.username = "Required!";
    } else if (formValues?.phone.length > 0 && (formValues?.phone.length < 8 || formValues?.phone.length > 10)) {
      errors.username = "Please enter valid phone number";
    }

    if (!formValues?.email || formValues?.email === "") {
      errors.email = "Required!";
    } else if (isValidEmail(formValues?.email) === false) {
      errors.email = "Please enter correct email address";
    }

    if (!formValues.password) {
      errors.password = "Required!";
    } else if (formValues.password.length < 8) {
      errors.password = "Must Contain 8 Characters";
    }

    console.log("formValues", formValues);
    console.log("errors", errors);

    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      console.log("formValues", formValues);
      console.log("errors", errors);
      addErrorToast("Please fix errors below", { hideAfter: 3 });
      return false;
    }
    return true
  }

  const registerConsumer = async () => {
    if (validateForm()) {
      const body = {
        countryCode: formValues.countryCode,
        phoneNumber: formValues.phone,
        socialType: "normal",
        userType: "student",
        /** checked by the server: an email that already belongs to another member account stops the sign-up */
        contactEmail: (formValues.email || "").trim(),
        /** lets the server say "already a member here" / "has an account" / "can't join online" */
        clubLink: logFor == "tenant" && tenant !== DEFAULT_TENANT ? tenant : myBookingLink,
      };

      dispatch(setActionLoading(true));
      const request = await axios.post(
        `${getUrlForUsers()}registration`,
        body
      );
      dispatch(setActionLoading(false));
      if (request.status === 200) {
        if (request.data.statusCode === 200) {
          console.log("sign up onBordingData", request.data.data);
          setOtpToken(request.data.data.token)
          setAddedByClub(request.data.data?.addedByClub === true)
          setSignupComplete(false)
          setOpenOtpModal(true)
          // addSuccessToast("Success!")
          // // dispatch(userActions.setOnBoardingData(onBordingData));
          // // navigation("/signup/verifynumber", {
          //   // navigation("/on-bording", {
          //   state: onBordingData,
          // });
        } else if (request.data.statusCode === 500 || request.data.statusCode === 403) {
          const message = typeof request?.data?.message === "string" ? request.data.message : "";
          /** Existing account: the server says which case without naming other clubs. Sign in first; the sign-in page offers to join. */
          const goToSignIn = () => navigate("/members/signin");
          if (message.indexOf("already a member of") !== -1) {
            addConfirmDialog({
              dialogType: "info",
              dialogTitle: "You're already a member",
              dialogMessage: message,
              btnCloseText: "Not now",
              btnConfirmText: "Sign in",
              onClose: () => { },
              onConfirm: goToSignIn,
            });
          } else if (message.indexOf("already have a FitClub account") !== -1) {
            addConfirmDialog({
              dialogType: "info",
              dialogTitle: "You already have an account",
              dialogMessage: message,
              btnCloseText: "Not now",
              btnConfirmText: "Sign in",
              onClose: () => { },
              onConfirm: goToSignIn,
            });
          } else if (message.indexOf("already belongs") !== -1 || message.indexOf("already exists") !== -1) {
            addConfirmDialog({
              dialogType: "info",
              dialogTitle: "This account already exists",
              dialogMessage: message,
              btnCloseText: "Not now",
              btnConfirmText: "Sign in",
              onClose: () => { },
              onConfirm: goToSignIn,
            });
          } else {
            addNotificationDialog({
              dialogType: "error",
              dialogTitle: "Sorry!",
              dialogMessage: message || "Something is wrong please try again",
              dialogBtnTitle: "OK",
              dialogBtnClick: () => { },
            })
          }
          return;
        } else {
          // addErrorToast("Oops, there seems to be a problem...");
          addNotificationDialog({
            dialogType: "error",
            dialogTitle: "Sorry!",
            dialogMessage: "Something is wrong please try again",
            dialogBtnTitle: "OK",
            dialogBtnClick: () => {
            },
          })
        }

      } else {
        addErrorToast("Oops, there seems to be a problem...");
      }
    }
  }


  const verifyOtp = async (otp = "", otpToken = "") => {

    const errors = {};
    if (otp === "") {
      errors.otp = "Required!";
    }
    if (otpToken === "") {
      errors.otp = "Required!";
    }
    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      addErrorToast("Please fix errors below", { hideAfter: 3 });
      return;
    }
    dispatch(setActionLoading(true));
    const body1 = {
      code: otp,
      token: otpToken,
    };
    const requestOtpVerification = await axios.post(
      `${getUrlForUsers()}verifyOtp`,
      body1
    );
    dispatch(setActionLoading(false));
    if (requestOtpVerification.status === 200) {
      if (requestOtpVerification.data.statusCode === 500) {
        addNotificationDialog({
          dialogType: "error",
          dialogTitle: "Sorry!",
          dialogMessage: requestOtpVerification.data.message,
          dialogBtnTitle: "OK",
          dialogBtnClick: async () => {
            // navigate("/", { replace: true });
          },
        })
        return;
      } else if (requestOtpVerification.data.statusCode === 201) {
        addNotificationDialog({
          dialogType: "error",
          dialogTitle: "Sorry!",
          dialogMessage: requestOtpVerification.data.message,
          dialogBtnTitle: "OK",
          dialogBtnClick: async () => {
            // navigate("/", { replace: true });
          },
        })
        return;
      }


      setOtpToken("")
      const { fullName, password, profilePic, socialType } = formValues;
      const body2 = {
        profilePic: formValues.profilePic,
        fullName: formValues.fullName,
        email: formValues.email,
        password: formValues.password,
        gender: formValues.gender,
        dob: formValues.dob ? formValues.dob : moment().subtract(20, "years").format("YYYY-MM-DD"),
        deviceType: "Web",
        token: requestOtpVerification.data.data.token,
        appToken: "tgdXUkmSARLj5txmsd8wY2u8kFXavQXG",
      };
      dispatch(setActionLoading(true));
      const requestUpdateLoginDetail = await axios.post(
        `${getUrlForUsers()}updateLoginDetail`,
        body2
      );
      dispatch(setActionLoading(false));
      if (requestUpdateLoginDetail.status === 200) {
        if (requestUpdateLoginDetail.data.statusCode === 200 && requestUpdateLoginDetail.data.data.token) {
          // call add member
          setUserToken(requestUpdateLoginDetail.data.data.token);

          dispatch(userActions.setBusinessType("class"));
          dispatch(userActions.setUserData(requestUpdateLoginDetail.data.data));
          await addMembers(requestUpdateLoginDetail.data.data.token)
        } else {
          addErrorToast("Oops, there seems to be a problem...");
        }
      } else {
        addErrorToast("Oops, there seems to be a problem...");
      }

    } else {
      addErrorToast("Oops, there seems to be a problem...");
    }
  };

  const addMembers = async (userToken = "") => {
    if (validateForm()) {

      let body = {
        // ...formValues,

        "username": formValues.username,
        "countryCode": formValues.countryCode,
        "phoneNumber": formValues.phone,
        "fullName": formValues.fullName,
        "email": formValues.email,
        // "profilePic": formValues.profilePic,
        // "password": formValues.password,
        // "gender": formValues.gender,
        // "dob": formValues.dob,
        "actionType": formValues.actionType || "free_trial_credit",
        "myBookingLink": logFor == "tenant" && tenant !== DEFAULT_TENANT ? tenant : myBookingLink,
      };

      // console.log("body", body);
      let config = {
        method: "post",
        url: `${getUrlForBookings()}addMembers`,
        data: body,
        headers: {
          "x-access-token": userToken,
        },
      };
      // console.log("config.body", body);
      // setSignupComplete(true)
      // console.log("config", config);
      // return;

      // dispatch(setGlobalLoading(true));
      dispatch(setActionLoading(true));
      const request = await axios(config);
      dispatch(setActionLoading(false));
      // dispatch(setGlobalLoading(false));

      if (request.status === 200) {
        if (request.data.statusCode === 200) {
          let purchasingInfo = request.data.data;
          // addSuccessToast("Your member added successfully");
          await onStudentLogin({
            username: formValues.username,
            password: formValues.password,
            appToken: "k4zJNUAAv9eGQbZXuZf0SPMnuhr6vXfl",
            deviceType: "Web",
            userType: "student",
          }, formValues)
          setSignupComplete(true)
          sprinkleConfetti();
          return;
          setFormValues(defaultFormData)
          // addNotificationDialog({
          //   dialogType: "success",
          //   dialogTitle: "Congratulations!",
          //   dialogMessage: "Welcome aboard! You are now a member of the Club. An email containing your membership details and next steps has been sent to your inbox.",
          //   dialogBtnTitle: "OK",
          //   dialogBtnClick: async () => {
          //     window.location.reload();
          //   },
          // })

          // return;

        } else if (request.data.statusCode === 403) {
          console.log("typeof ", typeof request?.data?.message);
          console.log("typeof ", request?.data?.message !== undefined && typeof request?.data?.message == "string");
          addNotificationDialog({
            dialogType: "error",
            dialogTitle: "Sorry!",
            dialogMessage: request?.data?.message !== undefined && typeof request?.data?.message == "string" ? request.data.message : "Something is wrong please try again",
            dialogBtnTitle: "OK",
            dialogBtnClick: async () => {
              window.location.reload();
            },
          })
        }
      } else {
        addErrorToast(request?.data?.message?.errors ? "Something is wrong please try again" : request.data.message);
        addNotificationDialog({
          dialogType: "error",
          dialogTitle: "Sorry!",
          dialogMessage: request?.data?.message?.errors ? "Something is wrong please try again" : request.data.message,
          dialogBtnTitle: "OK",
          dialogBtnClick: async () => {
            window.location.reload();
          },
        })
      }
      dispatch(setActionLoading(false));
      dispatch(setGlobalLoading(false));
      return;
    }

  };

  const onStudentLogin = async (body, values = null) => {
    dispatch(setActionLoading(true));
    const config = {
      method: "post",
      url: `${getUrlForUsers()}loginUser`,
      data: body,
    };
    try {
      const request = await axios(config);
      dispatch(setActionLoading(false));
      if (request.status === 200) {
        if (request.data.statusCode !== 200) {
          addErrorToast(request.data.message);
        } else {
          setUserToken(request.data.data.token);
          dispatch(userActions.setUserData(request.data.data));
          if (values) {
            dispatch(
              userActions.setUserPhone(values.formattedPhoneNumber)
            );
          }
          let userData = request.data.data

          if (userData.userType == "student") {
            dispatch(userActions.setBusinessType("class"));
            dispatch(userActions.setUserData(userData));
            // navigation("/members/schedule");
            return;
          }

        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const updateLoginDetailAndToken = async (token) => {
    const body2 = {
      deviceType: "Web",
      token: token,
      appToken: "tgdXUkmSARLj5txmsd8wY2u8kFXavQXG",
    };
    dispatch(setActionLoading(true));
    const requestUpdateLoginDetail = await axios.post(
      `${getUrlForUsers()}updateLoginDetail`,
      body2
    );
    dispatch(setActionLoading(false));
    if (requestUpdateLoginDetail.status === 200) {
      if (requestUpdateLoginDetail.data.statusCode === 200 && requestUpdateLoginDetail.data.data.token) {
        // call add member
        setUserToken(requestUpdateLoginDetail.data.data.token);

        dispatch(userActions.setBusinessType("class"));
        dispatch(userActions.setUserData(requestUpdateLoginDetail.data.data));
      } else {
        addErrorToast("Oops, there seems to be a problem...");
      }
    } else {
      addErrorToast("Oops, there seems to be a problem...");
    }
  };

  function sprinkleConfetti() {
    // Center burst
    confetti({
      particleCount: 120,
      spread: 70,
      startVelocity: 45,
      origin: { y: 0.6 },
      ticks: 200,
      scalar: 0.9,
    });

    // Side sprinkles for ~0.4s
    const end = Date.now() + 400;
    (function frame() {
      confetti({ particleCount: 20, angle: 60, spread: 55, origin: { x: 0 } });
      confetti({ particleCount: 20, angle: 120, spread: 55, origin: { x: 1 } });
      if (Date.now() < end) requestAnimationFrame(frame);
    })();
  }

  useEffect(() => {
    setFormErrors({});
    setFormValues(defaultFormData)
    getHostHomePage()
  }, [])


  React.useEffect(() => {
    if (logFor == "tenant" && ignoreDomainList.indexOf(tenant) >= 0) {
      addNotificationDialog({
        dialogType: "error",
        dialogTitle: "Club not found!",
        dialogMessage: "This club/gym is not registered on FitClub.",
        dialogBtnTitle: "Create your club account",
        isAllowBackdropClick: false,
        isDialogBtnShow: true,
        dialogBtnClick: async () => {
          window.location.href = `${getDomainUrl()}signup`;
        },
      })
    }
  }, [tenant]);

  const bd = businessDetail?.business_detail || {};
  const clubName = bd.businessName || "the club";
  const firstName = String(formValues?.fullName || "").trim().split(" ")[0];

  return (
    <TwMainLayout
      userType="skip"
      fullScreen={true} checkSession={false}>
      {bd.businessName ? (
        <AuthShell club={businessDetail} clubBadge={signupComplete ? null : "YOUR FIRST CLASS IS ON US"}>
          {signupComplete ? (
            <div className="flex flex-col gap-6">
              <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#E8F7EE]">
                <svg viewBox="0 0 24 24" fill="none" stroke="#1F8F4E" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" className="h-8 w-8" aria-hidden="true"><path d="M5 12l5 5L20 7" /></svg>
              </span>
              {addedByClub ? (
                <AuthHeading title={`Welcome${firstName ? `, ${firstName}` : ""}!`}>{clubName} had already added you. Your account is now active.</AuthHeading>
              ) : (
                <AuthHeading title={`Welcome aboard${firstName ? `, ${firstName}` : ""}!`}>You're now a member of {clubName}.</AuthHeading>
              )}
              <PrimaryAuthButton
                type="button"
                busy={loadingReduxState.actionLoading}
                onClick={() => {
                  let returnurl = urlParams.get('returnurl')
                  navigation(returnurl && returnurl !== "" ? returnurl : "/members/schedule");
                }}
              >
                {addedByClub ? "Book a class" : "Book your free trial class"} <ArrowRightIcon className="size-5" />
              </PrimaryAuthButton>
              <div className="border-t border-[#ECE8EE] pt-5">
                <p className="text-[15px] font-bold text-gray-900">Get the app: <span className="font-black">FitClub by BookzyMe</span></p>
                <div className="mt-3 flex flex-wrap gap-3">
                  <TwStoreButton btnType="apple" url="https://apps.apple.com/nl/app/fitclub-by-bookzyme/id1560700866?l=en-GB" />
                  <TwStoreButton btnType="google" url="https://play.google.com/store/apps/details?id=com.bookzy.fitclub" />
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-5">
              <AuthHeading title="Create your member account">Join {clubName} to book your classes.</AuthHeading>
              <div>
                <p className="text-sm font-bold text-gray-700">Profile photo <span className="font-semibold text-gray-500">(optional)</span></p>
                <p className="mb-3 mt-0.5 text-sm text-gray-600">
                  {formValues.profilePic
                    ? <><span className="font-bold text-[#1F6B3A]">Looking good!</span> Coaches and classmates at {clubName} will recognise you at your first class.</>
                    : <>Put a face to your name. Coaches and classmates at {clubName} will recognise you at your first class.</>}
                </p>
                <TwDropzone
                  variant={"profile"}
                  uploadBtnText={formValues.profilePic !== "" ? "Change Photo" : "Upload Photo"}
                  name={"profilePic"}
                  value={formValues.profilePic}
                  defaultValue={avatar_placeholder_vector}
                  errors={formErrors}
                  onChange={(image) => {
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      profilePic: image,
                    }));
                  }}
                />
              </div>
                      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 [&>*]:min-w-0">
                        <TwInputGroup
                          label={"Full name"}
                          name={"fullName"}
                          placeholder={"Your name"}
                          leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                          value={formValues.fullName}
                          onChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              fullName: e.target.value,
                            }));
                          }}
                          errors={formErrors}
                        />
                        <TwInputGroup
                          label={"Email"}
                          placeholder={"you@email.com"}
                          name={"email"}
                          leftIcon={(<img className={""} src={email_img} alt={""} />)}
                          value={formValues?.email}
                          onChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              email: e.target.value,
                            }));
                          }}
                          errors={formErrors}
                        />
                      </div>
                      <TwPhoneInputGroup
                        inputOuterClass="md:!py-3.5"
                        label={"Mobile number · you sign in with this"}
                        placeholder={"Mobile number"}
                        name={"username"}
                        value={formValues.username}
                        country={"nl"}
                        onChange={(phone, country, e) => {
                          const numberWithoutDialCode = phone.split("");
                          for (let i = 0; i < country.dialCode.length; i++) {
                            numberWithoutDialCode.shift();
                          }
                          let dialCode = country.dialCode;
                          if (
                            country.format.includes("+") &&
                            !country.dialCode.includes("+")
                          ) {
                            dialCode = "+".concat(country.dialCode);
                          }
                          // console.log("formattedPhoneNumber", e.target.value);
                          // console.log("mobile", dialCode + numberWithoutDialCode.join(""));
                          // props.form.setFieldValue("countryName", country.countryCode);
                          // props.form.setFieldValue("countryCode", dialCode);
                          // props.form.setFieldValue("phone", numberWithoutDialCode.join(""));
                          // props.form.setFieldValue("formattedPhoneNumber", e.target.value);
                          // props.form.setFieldValue("workNumber", e.target.value);
                          setFormValues((prevValues) => ({
                            ...prevValues,
                            countryCode: dialCode,
                            phone: numberWithoutDialCode.join(""),
                            formattedPhoneNumber: e.target.value,
                            username: dialCode + numberWithoutDialCode.join(""),
                            // mobile: numberWithoutDialCode.join(""),
                          }));
                        }}
                        helperText={"We'll text you a code to check it."}
                        errors={formErrors}
                      />

                      <TwInputGroup
                        label={"Password"}
                        placeholder={"At least 8 characters"}
                        name={"password"}
                        value={formValues?.password}
                        type={passwordVisible ? "text" : "password"}
                        leftIcon={(<img className={""} src={lock_img} alt={""} />)}
                        rightIcon={
                          <button type="button" className="flex" aria-label={passwordVisible ? "Hide password" : "Show password"} onClick={() => setPasswordVisible(!passwordVisible)}>
                            {passwordVisible ? <EyeIcon className="size-5" /> : <EyeSlashIcon className="size-5" />}
                          </button>
                        }
                        onChange={(e) => {
                          setFormValues((prevValues) => ({
                            ...prevValues,
                            password: e.target.value,
                          }));
                        }}
                        errors={formErrors}
                      />
                      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 [&>*]:min-w-0">
                        <TwSelectGroup label={"Gender (optional)"}
                          placeholder={"Select Gender"}
                          name={"gender"}
                          options={[
                            { value: "", title: "Select" },
                            { value: "Male", title: "Male" },
                            { value: "Female", title: "Female" },
                            { value: "Other", title: "Other" },
                          ]}
                          leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                          value={formValues.gender}
                          onChange={(e) => {
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              gender: e.target.value,
                            }));
                          }}
                          errors={formErrors} />
                        <TwCalendarPicker
                          label={"Date of birth (optional)"}
                          name={"dob"}
                          format="MM/DD/YYYY"
                          leftIcon={(<img className={""} src={calender_black} alt={""} />)}
                          value={(formValues.dob) ? formValues.dob : null}
                          onChange={(event) => {
                            const newValue = event?.toDate();
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              dob: newValue,
                            }));
                          }}
                          errors={formErrors} />
                      </div>
              <PrimaryAuthButton type="button" busy={loadingReduxState.actionLoading} onClick={() => registerConsumer()}>
                Join {clubName}
              </PrimaryAuthButton>
              <p className="text-center text-[13px] text-gray-500">
                By joining you accept our{" "}
                <a className="font-bold text-gray-700 underline" href={"https://www.bookzyme.com/terms-and-conditions.html"} target="_blank" rel="noreferrer">Terms of Use</a>
                {" "}and{" "}
                <a className="font-bold text-gray-700 underline" href={"https://www.bookzyme.com/privacy-policy.html"} target="_blank" rel="noreferrer">Privacy Policy</a>.
              </p>
              {logFor === "tenant" && (
                <p className="text-center text-[15px] text-gray-600">
                  Already a member?{" "}
                  <button type="button" className="font-extrabold text-indigo-bz hover:underline" onClick={() => navigation("/members/signin")}>Sign in</button>
                </p>
              )}
            </div>
          )}
        </AuthShell>
      ) : null}
        <OtpModal
          open={openOtpModal}
          handleClose={() => { setOpenOtpModal(false) }}
          title={"Verify Number"}
          subTitle={formValues.username ? formValues.username : ""}
          values={{}}
          // reqToken={"otpToken"}
          skipVerify={true}
          onResendCode={async (otp) => {
            await registerConsumer(otp, otpToken)
          }}
          onSubmit={async (otp) => {
            await verifyOtp(otp, otpToken)
          }}
        />
    </TwMainLayout>)
}
